/**
 *
 *@author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

/*eslint-disable*/
module.exports = {
	VKBlock: true,
	gs: { // game settings
		"size": {
			"480": {"scr": {"w": 360, "h": 360}, "cll": {"w": 40, "h": 40}},
			"576": {"scr": {"w": 450, "h": 450}, "cll": {"w": 50, "h": 50}},
			"720": {"scr": {"w": 495, "h": 495}, "cll": {"w": 55, "h": 55}},
			"1080": {"scr": {"w": 765, "h": 765}, "cll": {"w": 85, "h": 85}}
		},
		"infoItems": {"x": 9, "y": 9},
		"position": {"old": {"x": 0, "y": 0}, "current": {"x": 0, "y": 0}},
		"items": {"x": 9, "y": 9},
		"squares": [
			[
				[0, 0],
				[0, 1],
				[0, 2],
				[1, 0],
				[1, 1],
				[1, 2],
				[2, 0],
				[2, 1],
				[2, 2]
			],
			[
				[0, 3],
				[0, 4],
				[0, 5],
				[1, 3],
				[1, 4],
				[1, 5],
				[2, 3],
				[2, 4],
				[2, 5]
			],
			[
				[0, 6],
				[0, 7],
				[0, 8],
				[1, 6],
				[1, 7],
				[1, 8],
				[2, 6],
				[2, 7],
				[2, 8]
			],
			[
				[3, 0],
				[3, 1],
				[3, 2],
				[4, 0],
				[4, 1],
				[4, 2],
				[5, 0],
				[5, 1],
				[5, 2]
			],
			[
				[3, 3],
				[3, 4],
				[3, 5],
				[4, 3],
				[4, 4],
				[4, 5],
				[5, 3],
				[5, 4],
				[5, 5]
			],
			[
				[3, 6],
				[3, 7],
				[3, 8],
				[4, 6],
				[4, 7],
				[4, 8],
				[5, 6],
				[5, 7],
				[5, 8]
			],
			[
				[6, 0],
				[6, 1],
				[6, 2],
				[7, 0],
				[7, 1],
				[7, 2],
				[8, 0],
				[8, 1],
				[8, 2]
			],
			[
				[6, 3],
				[6, 4],
				[6, 5],
				[7, 3],
				[7, 4],
				[7, 5],
				[8, 3],
				[8, 4],
				[8, 5]
			],
			[
				[6, 6],
				[6, 7],
				[6, 8],
				[7, 6],
				[7, 7],
				[7, 8],
				[8, 6],
				[8, 7],
				[8, 8]
			]
		],

		"complexity": {
			"easy": [
				/*[0,9,0,9,0,9,0,9,0],*/
				[3, 5, 4, 4, 4, 4, 4, 5, 3],
				[5, 4, 4, 3, 5, 3, 3, 4, 5],
				[4, 4, 4, 4, 4, 4, 4, 4, 4],
				[5, 3, 3, 4, 5, 4, 3, 3, 5],
				[5, 2, 4, 3, 6, 3, 4, 2, 6],
				[3, 3, 5, 4, 5, 4, 5, 3, 3]
			],
			"normal": [
				[2, 4, 3, 3, 3, 3, 3, 4, 2],
				[4, 3, 3, 2, 4, 2, 2, 3, 4],
				[3, 3, 3, 3, 3, 3, 3, 3, 3],
				[4, 2, 2, 3, 4, 3, 2, 2, 4],
				[5, 1, 3, 2, 5, 2, 3, 1, 5],
				[2, 2, 4, 3, 4, 3, 4, 2, 2]
			],
			"hard": [
				[0, 3, 2, 2, 2, 2, 2, 3, 1],
				[3, 2, 2, 1, 3, 1, 1, 2, 3],
				[2, 2, 2, 2, 2, 2, 2, 2, 2],
				[3, 1, 1, 2, 3, 2, 1, 1, 3],
				[4, 0, 2, 1, 4, 1, 2, 0, 4],
				[1, 1, 3, 2, 3, 2, 3, 1, 1]
			]
		}
	}
}
;
